module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/battery-empty-81c3d7f26843fd3533d466768c58cd0a.svg";